/**
 * Reemplaza símbolos de viñetas por guiones.
 * Se aplica en el onChange y OnSubmit tambien para que lipie los casos que ya vienen de la base y no se modifiquen.
 * @param {string} text - El texto a limpiar.
 * @returns {string} El texto con las viñetas reemplazadas por guiones.
 */
export const replaceBulletPoints = text => {
  if (!text) return '';
  return text.replace(/[•▪▫◦‣⁃⁌⁍●○◘◙■□▢▣▤▥▦▧▨▩☆★]/g, '-');
};

/**
 * Elimina caracteres no válidos del texto.
 * Permite letras, marcas diacríticas, números, puntuación, espacios y saltos de línea.
 *
 * @param {string} text - El texto a limpiar.
 * @returns {string} El texto sin caracteres no válidos.
 */
export const removeInvalidCharacters = text => {
  if (!text) return '';
  return text.replace(/[^\p{L}\p{M}\p{N}\p{P}\p{S}\p{Zs}\n\r\t]/gu, '');
};

/**
 * Reemplaza etiquetas <br> por saltos de línea.
 *
 * @param {string} text - El texto a limpiar.
 * @returns {string} El texto con <br> reemplazados por saltos de línea.
 */
export const replaceBrTagsWithNewlines = text => {
  if (!text) return '';
  return text.replace(/<br\s*\/?>/gi, '\n');
};

/**
 * Convierte secuencias \\n literales en saltos de línea reales.
 *
 * @param {string} text - El texto a limpiar.
 * @returns {string} El texto con \\n convertidos en saltos de línea.
 */
export const convertLiteralNewlines = text => {
  if (!text) return '';
  return text.replace(/\\n/g, '\n');
};

/**
 * Elimina backslashes solitarios del texto.
 *
 * @param {string} text - El texto a limpiar.
 * @returns {string} El texto sin backslashes.
 */
export const removeBackslashes = text => {
  if (!text) return '';
  return text.replace(/\\/g, '');
};

/**
 * Elimina emojis del texto, incluyendo emojis numéricos (keycaps) y todas las variantes.
 *
 * @param {string} text - El texto a limpiar.
 * @returns {string} El texto sin emojis.
 */
export const removeEmojis = text => {
  if (!text) return '';

  // Regex más completa que elimina emojis pero preserva números normales
  // Esta regex captura:
  // - Emojis estándar con variation selectors
  // - Keycaps numéricos (0️⃣-9️⃣)
  // - Secuencias ZWJ (zero-width joiner)
  // - Modificadores de tono de piel
  // - Banderas
  let cleaned = text.replace(
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
    ''
  );

  return cleaned;
};

/**
 * Elimina caracteres especiales y emojis de un texto.
 *
 * @param {string} text - El texto a limpiar.
 * @returns {string} El texto sin caracteres especiales y emojis.
 */
export const removeSpecialCharsAndEmojis = text => {
  if (!text) return '';
  return removeEmojis(
    removeBackslashes(
      convertLiteralNewlines(replaceBrTagsWithNewlines(removeInvalidCharacters(replaceBulletPoints(text))))
    )
  );
};
